import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";
import { streamAI } from "../lib/ai";

export const AiButton = ({ body, onText, previous, label = "Write with AI", testId }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    const before = previous || "";
    setBusy(true);
    try {
      const text = await streamAI(body(), onText);
      onText(text);
      toast.success("Done — edit it any way you like", before ? { action: { label: "Undo", onClick: () => onText(before) } } : undefined);
    } catch (e) {
      onText(before);
      toast.error(e.message);
    }
    setBusy(false);
  };
  return (
    <button type="button" onClick={run} disabled={busy} data-testid={testId}
      className="inline-flex items-center gap-1.5 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-3 py-1 text-xs font-medium text-emerald-300 hover:bg-emerald-500/20 transition-colors disabled:opacity-60">
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Sparkles className="h-3.5 w-3.5" />}
      {busy ? "Writing…" : label}
    </button>
  );
};

export const SummaryAssist = ({ resumeId, onText, previous }) => {
  const [notes, setNotes] = useState("");
  return (
    <div className="mt-5 rounded-xl border border-white/10 bg-white/[0.02] p-4 space-y-3" data-testid="ai-summary-box">
      <p className="text-xs text-slate-400">A few words about you, e.g. <span className="text-slate-300">"8 yrs nursing, ICU, love mentoring"</span></p>
      <input value={notes} onChange={(e) => setNotes(e.target.value)} maxLength={1000} data-testid="ai-summary-notes"
        className="w-full h-10 rounded-md bg-[#0c0e14] border border-white/10 px-3 text-sm placeholder:text-slate-600 focus:outline-none focus:ring-2 focus:ring-emerald-500"
        placeholder="Your strengths, years of experience, goals…" />
      <AiButton testId="ai-summary-btn" label="Write my summary" onText={onText} previous={previous}
        body={() => ({ kind: "summary", resume_id: resumeId, notes })} />
    </div>
  );
};
